import React from "react";
import styled, { themeGet, device, color } from "@styled";

export const SectionWrap = styled.section`
    padding-top: 60px;
    padding-bottom: 30px;
    background-color: ${themeGet("colors.gray.100")};
`;
